import { useState, useEffect, useMemo } from 'react'

import API from '../../../../api/api'
import { getTrainerOptions } from '../helpers'

export const useTrainerOptions = (userData) => {
  const [trainers, setTrainers] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const isManagerOrAdmin = ['Manager', 'Administrator'].includes(userData.user.role)

  const trainerOptions = useMemo(() => {
    return trainers.length ? getTrainerOptions(trainers) : []
  }, [trainers])

  const fetchTrainers = async () => {
    try {
      setIsLoading(true)
      const data = await API.getTrainersWithoutUserData()

      setTrainers(data || [])
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }

    setIsLoading(false)
  }

  useEffect(() => {
    if (isManagerOrAdmin) {
      fetchTrainers()
    }
  }, [])

  return { trainerOptions, isLoading }
}
